import { DateTime } from 'luxon';

export const profileNotes = {
    namespaced: true,

    state: {
        filter: {
            startDate: DateTime.now().minus({ months: 1 }).toISODate(),
            endDate: DateTime.now().toISODate()
        }
    },

    getters: {
        filter(state) {
            return state.filter;
        }
    },

    mutations: {
        setStartDate(state, date) {
            state.filter.startDate = date;
        },

        setEndDate(state, date) {
            state.filter.endDate = date;
        }
    }
};

export default profileNotes;
